export const NavLinks = {
  facebook: 'https://www.facebook.com/avidadventures/',
  linkedin: 'https://www.linkedin.com/company/avidadventures/',
  mail: 'https://witgritfit.com/contact-us/',
  text: [
    { 'Privacy Policy': 'https://witgritfit.com/privacy-policy/' },
    { 'Terms of Use': 'https://witgritfit.com/terms-of-use/' },
  ],
};
